import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { FlatNode, TreeComponent, TreeNode } from '../../';
import { SidebarItemComponent } from './sidebar-item.component';

@Component({
  selector: 'ui-center-sidebar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TreeComponent, SidebarItemComponent],
  template: `
    <ui-tree
      [data]="dataTree()"
      (onNode)="handleNode($event)"
      [canExpand]="canExpand()"
    />

    <ng-template #item let-item>
      <ui-sidebar-item [item]="item" />
    </ng-template>
  `,
})
export class CenterSidebarComponent {
  tree = input<TreeNode[]>([]);
  canExpand = input<boolean>(true);
  itemTemplateSig = viewChild<TemplateRef<any>>('item');
  dataTree = computed(() =>
    this.mapItemTemplate(this.tree(), this.itemTemplateSig()),
  );

  TREE_DATA: TreeNode[] = [];

  sendInfraestructureIds = output<{
    rsabtId: string;
    tsabtId: string | null;
    vtnId?: string;
  }>();

  private mapItemTemplate(data: TreeNode[], template: any): TreeNode[] {
    const valueToReplace = '{{itemTemplate}}';
    const newValue = template;
    if (data?.length) {
      for (const item of data) {
        if (item?.template === valueToReplace) {
          item.template = newValue;
        }
        if (item.children) {
          this.mapItemTemplate(item.children, template);
        }
      }
    }
    return data;
  }

  handleNode(node: FlatNode) {
    let rsabtId, tsabtId, vtnId;
    const isRsabtId = node.level === 0;
    const isTsabtId = node.level === 2;
    if (isRsabtId) {
      rsabtId = node.context?.subId;
      vtnId = node.context?.vtnId;
    };
    if (isTsabtId) {
      tsabtId = node.context?.subId;
      rsabtId = node.context?.rsabtId;
      vtnId = node.context?.vtnId;
    }
    this.sendInfraestructureIds.emit({
      rsabtId: rsabtId,
      tsabtId: tsabtId,
      vtnId: vtnId,
    });
  }
}
